import { render, staticRenderFns } from "./CodemirrorEditor.vue?vue&type=template&id=5d76dc09"
import script from "./CodemirrorEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./CodemirrorEditor.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports